import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Pending } from 'components/Profile/Pending';
import { MINDBODY } from 'constants/reservation-sources';
import { pick } from 'helpers/object';
import { messages } from './CancelReservationModal.messages';
import { CancelReservationInquiry } from './ModalStates/CancelReservationInquiry';
import { CancelReservationResult } from './ModalStates/CancelReservationResult';
export var CancelReservationModal =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CancelReservationModal, _PureComponent);

  function CancelReservationModal() {
    _classCallCheck(this, CancelReservationModal);

    return _possibleConstructorReturn(this, _getPrototypeOf(CancelReservationModal).apply(this, arguments));
  }

  _createClass(CancelReservationModal, [{
    key: "renderCancellationError",
    value: function renderCancellationError() {
      var resultProps = pick(['studio', 'onModalClose'], this.props);
      return React.createElement(CancelReservationResult, _extends({}, resultProps, {
        details: React.createElement(FormattedHTMLMessage, messages.cancellationFailure),
        heading: React.createElement(FormattedMessage, messages.cancellationFailureHeading),
        type: "error"
      }));
    }
  }, {
    key: "renderCancellationInquiry",
    value: function renderCancellationInquiry() {
      var inquiryProps = pick(['cancellationPolicy', 'credits', 'endTimestamp', 'image', 'late', 'name', 'requestCancelReservation', 'reservationId', 'startTimestamp', 'studio'], this.props);
      return React.createElement(CancelReservationInquiry, inquiryProps);
    }
  }, {
    key: "renderCancellationPending",
    value: function renderCancellationPending() {
      return React.createElement(Pending, null, React.createElement(Pending.CancelReservation, null));
    }
  }, {
    key: "renderCancellationSuccess",
    value: function renderCancellationSuccess() {
      var resultProps = pick(['studio', 'onModalClose'], this.props);
      return React.createElement(CancelReservationResult, _extends({}, resultProps, {
        details: React.createElement(FormattedMessage, messages.cancellationSuccess),
        heading: React.createElement(FormattedMessage, messages.cancellationSuccessHeading),
        type: "success"
      }));
    }
  }, {
    key: "renderReservationLoading",
    value: function renderReservationLoading() {
      return React.createElement(Pending, null, React.createElement(Pending.LoadReservation, null));
    }
  }, {
    key: "renderMindBodyFooter",
    value: function renderMindBodyFooter() {
      var _this$props = this.props,
          isCancellationPending = _this$props.isCancellationPending,
          isReservationLoading = _this$props.isReservationLoading,
          source = _this$props.source;
      var shouldRenderMindBodyLogo = !isReservationLoading && !isCancellationPending && source === MINDBODY;

      if (shouldRenderMindBodyLogo) {
        return React.createElement("a", {
          href: "https://www.mindbodyonline.com/",
          target: "_blank",
          rel: "noopener noreferrer",
          className: "modal__powered-by"
        }, React.createElement(FormattedMessage, messages.poweredByMindbody, function (message) {
          return React.createElement("img", {
            src: "/img/mindbody-powered-logo.png",
            alt: message,
            width: "140",
            height: "43"
          });
        }));
      }
    }
  }, {
    key: "renderModalContents",
    value: function renderModalContents() {
      var _this$props2 = this.props,
          isCancellationError = _this$props2.isCancellationError,
          isCancellationPending = _this$props2.isCancellationPending,
          isCancelled = _this$props2.isCancelled,
          isReservationLoading = _this$props2.isReservationLoading;

      if (isReservationLoading) {
        return this.renderReservationLoading();
      }

      if (isCancellationPending) {
        return this.renderCancellationPending();
      }

      if (isCancellationError) {
        return this.renderCancellationError();
      }

      if (isCancelled) {
        return this.renderCancellationSuccess();
      }

      return this.renderCancellationInquiry();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "modal__cancellation"
      }, this.renderModalContents(), this.renderMindBodyFooter());
    }
  }]);

  return CancelReservationModal;
}(PureComponent);
CancelReservationModal.propTypes = {
  cancellationPolicy: PropTypes.string.isRequired,
  credits: PropTypes.number,
  endTimestamp: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  isCancellationError: PropTypes.bool.isRequired,
  isCancellationPending: PropTypes.bool.isRequired,
  isCancelled: PropTypes.bool.isRequired,
  isReservationLoading: PropTypes.bool.isRequired,
  late: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onModalClose: PropTypes.func.isRequired,
  requestCancelReservation: PropTypes.func.isRequired,
  reservationId: PropTypes.number.isRequired,
  source: PropTypes.string.isRequired,
  startTimestamp: PropTypes.number.isRequired,
  studio: PropTypes.string.isRequired
};